import { BaseFeedbackConIcona, BaseContenutoConProgress } from '@lucan/base-ui'
import { useSessione } from 'context/SessioneProvider'
import { Box, Card, CardContent, Chip, Typography, Grid, Button, CardActions } from '@mui/material'
import Titolo from 'components/ui/Titolo'
import Sottotitolo from 'components/ui/Sottotitolo'
import Contenitore from 'components/ui/Contenitore'
import { Link as RouterLink } from 'react-router-dom';
import ConfigManager from 'components/config/ConfigManager'
import { LINK_SERVIZI } from 'configuration/link'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import Breadcrumbs from 'components/ui/Breadcrumbs'
import { useAppContext } from 'GlobalContext'


const CFG = LINK_SERVIZI


export default function Home() {

  const { ScatolaMessaggi, messaggioErrore, inAttesaDelServer } = useSessione()
  
  return (
    <>
      {ScatolaMessaggi}

      {messaggioErrore && <BaseFeedbackConIcona.Errore messaggio={messaggioErrore} />}

      <BaseContenutoConProgress inAttesa={inAttesaDelServer}>
        <ConfigManager elenchiConfig={[ELENCHI.CFG_LINK_SERVIZI]}>
          {propsConfig => <LoginUtenteOChiaveVerbale {...propsConfig} />}
        </ConfigManager >         
      </BaseContenutoConProgress>
    </>
  )
}



function LoginUtenteOChiaveVerbale(props) {
  const {val, txt} = props
  const { intermediario } = useAppContext() 
  const serviziConfig = [
    {
      attivo: val(CFG.FRONTOFFICE_ATTIVO),
      titolo: CFG.FRONTOFFICE_TITOLO,
      descrizione: CFG.FRONTOFFICE_DESCRIZIONE,
      link: val(CFG.FRONTOFFICE_URL)?.trim() || "frontoffice"
    },
    {
      attivo: val(CFG.DATICONDUCENTE_ATTIVO),
      titolo: CFG.DATICONDUCENTE_TITOLO,
      descrizione: CFG.DATICONDUCENTE_DESCRIZIONE,
      link: val(CFG.DATICONDUCENTE_URL)?.trim() || "datiConducente"
    },
    {
      // Aggiungiamo la condizione extra dell'intermediario direttamente qui
      attivo: val(CFG.PASS_ATTIVO) && intermediario,
      titolo: CFG.PASS_TITOLO,
      descrizione: CFG.PASS_DESCRIZIONE,
      link: val(CFG.PASS_URL)?.trim() || "pass"
    }
  ];
  const serviziAttivi = serviziConfig.filter(s => s.attivo);

  return (<>
    <Contenitore sx={{mb:4}}>
        <Breadcrumbs sx={{ mb: 3 }} {...val(CFG.BREADCRUMBS)} />
        <Titolo>{txt(CFG.TITOLO)}</Titolo>      
        <br />
        <Sottotitolo grigio>{txt(CFG.DESCRIZIONE)}</Sottotitolo>
      </Contenitore>
      <Box sx={{boxShadow: 'inset 0 10px 14px -12px rgba(0,0,0,.34)' , backgroundColor: '#ebeef0', width:'100%' }}>
         <Contenitore sx={{ background: 'none', py: 4 }}>
        <Grid container spacing={3}>
          {serviziAttivi.length > 0 ? (
            // Se ci sono servizi, li mappiamo
            serviziAttivi.map((servizio, index) => (
              <ServizioCard
                key={index}
                titolo={servizio.titolo}
                descrizione={servizio.descrizione}
                link={servizio.link}
                {...props}
              />
            ))
          ) : (
            // Se l'array è vuoto, mostriamo il messaggio
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ textAlign: 'center', py: 2 }}>
                {txt(CFG.DESCRIZIONE_NO_SERVIZIO)}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Contenitore>
      </Box>      
    </>
  )
}

const ServizioCard = ({titolo, descrizione,link, txt, val})   => {

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card elevation={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '398px' }}>
        <CardContent>
          <Typography variant="overline" color="primary" gutterBottom>
            {CFG.SERVIZIO_ONLINE?.trim() && txt(CFG.SERVIZIO_ONLINE)}
          </Typography>
          <Typography variant="h6" component="div" gutterBottom sx={{my:2}}>
            {txt(titolo)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {txt(descrizione)}
          </Typography>
        </CardContent>
        <CardActions>
          <ButtonLink size="small" href={link} endIcon={<span>&rarr;</span>} >
           {txt(CFG.VAI_ALLA_PAGINA)}
          </ButtonLink>
        </CardActions>
      </Card>
    </Grid>
  )
}

const ButtonLink = ({ label, href, color='primary', variant='text', size = 'medium' , children, ...rest }) => {
  const isExternal = href.startsWith('http');
  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      component={isExternal ? 'a' : RouterLink}
      href={isExternal ? href : undefined}
      to={!isExternal ? href : undefined}
      sx={{ my: 1 }}
      {...rest}
    >
      {label || children}
    </Button>
  );
};